import { useSubmit } from '@remix-run/react';

export const useAction = () => {
	const submit = useSubmit();

	const submitAction = (url: string) =>
		submit(null, {
			method: 'post',
			action: url,
			navigate: false,
		});

	const fetchAction = (url: string) =>
		fetch(url, {
			method: 'post',
		}).then(() => {
			window.location.reload();
		});

	return { submitAction, fetchAction };
};
